<template>
    <div class="bg-white full-height">
        <dicta-header :english-supported="false" :showPromotions="'nakdan'" v-if="nakdanStyle.Mobile"></dicta-header>
        <mobile-home-header v-if="nakdanStyle.Mobile" />
        <div v-if="documentSettingsPane" class="container full-height">
            <b-row no-gutters class="full-height">
                <b-col class="full-height" cols="9">
                    <main-input/>
                </b-col>
                <b-col cols="3">
                    <document-settings class="settings"/>
                </b-col>
            </b-row>
            <welcome v-if="useWelcomePopup" ref="welcome-popup" v-on:show-keyboard-shortcuts="$emit('show-keyboard-shortcuts')"/>
        </div>
        <main-input v-else />
        <mobile-footer @showHowDialog="openHowItWorks" v-if="nakdanStyle.Mobile" :english-supported="false" :howDialog="true"/>
        <failed-validation-popup />
        <howPopup v-model="showHowItWorks"/>
    </div>
</template>

<script>
    // @ is an alias to /src
    import DocumentSettings from '@/components/DocumentSettings.vue'
    import MainInput from '@/components/MainInput.vue'
    import Welcome from '@/components/Welcome.vue'
    import {Actions} from '@/store/stateChanges'
    import serviceMixins from '@/mixins/serviceMixins'
    import FailedValidationPopup from '@/components/FailedValidationPopup.vue'
    import {SimpleVsProConfig} from '@/simpleVsProConfig.js'
    import {NakdanStyle, MobileVsDesktopConfig} from '@/mobileVsDesktopConfig.js'
    import MobileHomeHeader from '@/components/MobileHomeHeader.vue'
    import howPopup from '@/components/howMobilePopup.vue'

    export default {
        name: 'TextPrep',
        components: {
            MobileHomeHeader,
            DocumentSettings,
            MainInput,
            Welcome,
            FailedValidationPopup,
            howPopup
        },
        mixins: [serviceMixins], // for googleAnalyticsId and gtag()
        data() {
            return {
                showWelcomePopup: true,
                showHowItWorks: false
            }
        },
        methods: {
            openHowItWorks () {
               this.showHowItWorks = true
            }
        },
        computed: {
            nakdanStyle () {
                return NakdanStyle // Mobile: window.innerWidth < 992, Desktop: window.innerWidth >= 992
            },
            documentSettingsPane () {
                return MobileVsDesktopConfig.DOCUMENT_SETTINGS_PANE
            },
            useWelcomePopup () {
                return SimpleVsProConfig.USE_WELCOME_POPUP
            }
        },
        mounted() {
            this.gtag('config', this.googleAnalyticsId, {'page_title': 'textprep', 'page_path': '/'})
            this.$store.dispatch(Actions.INITIALIZE_APPLICATION)
            const mediaQueryBigEnough = window.matchMedia('(min-width: 768px)').matches
            if (this.useWelcomePopup && this.$store.state.firstTimeInitialized && mediaQueryBigEnough) {
                this.$refs['welcome-popup'].$children[0].show() // the $ref is the COMPONENT, $children[0] is the modal
            }
        },
        beforeDestroy() {
            // (will have to be imported if we uncomment this) StateSaver.saveState(this.$store.state)
        }

    }
</script>

<style scoped>
</style>
